import TomSelect from 'tom-select/dist/js/tom-select.base.js'

up.on('click', '[data-dismissible-filter]', (event: Event) => {
  const target = event.target as HTMLElement
  const form = target.closest('form')!
  target.remove()
  up.submit(form)
})

up.on('click', '[data-dismissible-filter-clear-place]', (event: Event) => {
  const target = event.target as HTMLElement
  const form = target.closest('form')!
  const placeSelect = form.querySelector('[name="place"]') as HTMLSelectElement & {
    tomselect: InstanceType<typeof TomSelect>
  }
  placeSelect.tomselect.clear()
  up.submit(form)
})
